(function () {
  if (window.berndorfNewsletterBound) return;
  window.berndorfNewsletterBound = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-berndorf-brevo-form]');
    if (!form) return;
    event.preventDefault();

    const success = form.querySelector('[data-newsletter-success]');
    const error = form.querySelector('[data-newsletter-error]');
    const button = form.querySelector('button[type="submit"]');
    const url = new URL(form.action);
    url.searchParams.set('isAjax', '1');

    error.hidden = true;
    success.hidden = true;
    button.disabled = true;

    try {
      const response = await fetch(url, { method: 'POST', body: new URLSearchParams(new FormData(form)) });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error('newsletter signup rejected');
      form.reset();
      success.hidden = false;
      success.focus();
      try {
        localStorage.setItem('berndorf-newsletter-subscribed', String(Date.now()));
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('berndorf:newsletter-subscribed'));
    } catch (e) {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
})();
